import { useAtom, useAtomValue } from 'jotai'
import {
  drawAreasAtom,
  elementFiltersAtom,
  hasRiskFiltersAtom,
  nonEmptyElementFiltersAtom,
  regionMasksAtom,
} from '@app/risk-migration/atoms/riskFilters.atoms'

export function useRiskFilterState() {
  const [elementFilters, setElementFilters] = useAtom(elementFiltersAtom)
  const [drawAreas, setDrawAreas] = useAtom(drawAreasAtom)
  const [regionMasks, setRegionMasks] = useAtom(regionMasksAtom)
  const nonEmptyElementFilters = useAtomValue(nonEmptyElementFiltersAtom)
  const hasFilters = useAtomValue(hasRiskFiltersAtom)

  return {
    elementFilters,
    setElementFilters,
    drawAreas,
    setDrawAreas,
    regionMasks,
    setRegionMasks,
    nonEmptyElementFilters,
    hasFilters,
  }
}
